import { useEffect } from 'react'
import { useEoValue } from '~/src/hooks/useEoState'
import useAuthenticationFlowDialogs from '~/src/hooks/auth/flow/useAuthenticationFlowDialogs'
import { Customer } from '@eo-storefronts/eo-core'
import { CUSTOMER_STATE } from '~/src/stores/customer'
import { AuthenticationFlowDialogNameEnum } from '~/src/types/DialogNameEnum'
import useCustomerExtraInfo from '~/src/hooks/customer/useCustomerExtraInfo'
import useCustomerProfilePasswordFieldState
  from '~/src/hooks/forms/customer-profile-form/useCustomerProfilePasswordFieldState'

const useCustomerMissingFieldsEffect = () => {
  const customer = useEoValue<Customer | null>(CUSTOMER_STATE)
  const { goToStep } = useAuthenticationFlowDialogs()
  const { needsExtraInfo } = useCustomerExtraInfo()
  const { isRequired: isPasswordRequired } = useCustomerProfilePasswordFieldState()

  useEffect(() => {
    if (
      !customer ||
      (
        !needsExtraInfo(customer) &&
        !isPasswordRequired ||
        (isPasswordRequired && !!customer.password)
      )
    ) {
      return
    }

    goToStep(AuthenticationFlowDialogNameEnum.AUTHENTICATION_FLOW_CUSTOMER_MISSING_FIELDS)
  }, [ customer ])
}

export default useCustomerMissingFieldsEffect
